<template>
    <div v-if="logged_in" id="login-button">
        <v-dialog v-model="login_dialog" persistent max-width="600px">
            <v-btn class="hidden-sm-and-down" flat style="height:100%;width:20vw;padding:0;" slot="activator"><v-img :src="row1_img1" /></v-btn>
            <v-btn class="hidden-md-and-up" flat style="height:100%;width:35vw;padding:0;" slot="activator"><v-img :src="row1_img1" /></v-btn>
            <v-card>
            <v-card-title>
                <span class="headline">{{login_title}}</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout wrap>                        
                    <v-flex xs12>
                    <v-text-field v-model="loginemail" required>
                        <template v-slot:label>
                            {{lbl_username}}
                            </template>
                    </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                    <v-text-field v-model="loginpassword" type="password" required>
                        <template v-slot:label>
                            {{lbl_password}}
                            </template>
                    </v-text-field>
                    </v-flex>                                                  
                </v-layout>
                </v-container>
                <small></small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="login_dialog = false">{{close}}</v-btn>
                <v-btn color="blue darken-1" flat @click="login">{{login_text}}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>           
    </div>
</template>

<script>
import { all } from 'q';
// import { uuid } from 'vue-uuid';

if(localStorage.getItem('language')===null||localStorage.getItem('language')==""){
        var userLang = navigator.languages[navigator.languages.length-1] || navigator.userLanguage;
        localStorage.setItem('language',userLang);      
      }

let language=localStorage.getItem('language');


var logged = true;

export default {
    beforeCreate() {
        var token = localStorage.getItem('token')
        if(token!==null){
            logged = false
        } 
    },    
    data(){
        
        if (language=='es') 
        
        {
            return{
                logged_in:logged,
                dialog:false,
                login_title:"Acceso",
                login_dialog: false,
                loginemail:'',
                loginpassword:'',
                row1_img1:'./btn__iniciarsesion.png',
                close:'Cerrar',
                login_text:'Acceder',
                lbl_username:'Usuario/Email',
                lbl_password:'Contraseña'
            }
        }else{
            return{
                logged_in:logged,
                dialog:false,
                login_title:"Login",
                login_dialog: false,
                row1_img1:'iniciarsesion_eng.png',
                loginemail:'',
                loginpassword:'',
                close:'Close',
                login_text:'Sign In',
                lbl_username:'User/Email',
                lbl_password:'Password'
            }
        }
    },
    methods:{
    login: function () {        
        let username = this.loginemail 
        let password = this.loginpassword
        let client_id= '5c6c4ada410dfba504749c41';
        let client_secret = 'pP9s493s8xlzADfdMneOEgzrZ3J5l46CLXk5OLE8'
        let grant_type = 'password'
        let scope = '*'
        this.$store.dispatch('login', { grant_type, username, password,client_id,client_secret,scope })
       .then( () =>
           this.$router.push('/descargas')        
       ).catch(function () {
           alert("Usuario/Contraseña incorrecto");
       }
       )
      }
    }
}
</script>